import {IShortLocation, IShortServiceProvider, IShortUser, IShortProfessionalServiceData} from "@/model/shortInterfaces";
import {IPromotion} from "@/model/Promotions/IPromotion";
import {IService} from "@/model/Service/serviceInterfaces";
import {ICell} from "@/model/Locker/lockerInterfaces";
import {ICommunicationMessage} from "@/model/Communication/ICommunicationMessage";

export enum EOrderStatuses {
  status_order_new = 'status_order_new',
  status_order_completed = 'status_order_completed',
  status_order_awaiting_customer_dropoff = 'status_awaiting_customer_dropoff',
  status_order_awaiting_collect = 'status_order_awaiting_collect',
  status_order_in_route_collect = 'status_order_in_route_collect',
  status_order_sp_collected = 'status_order_sp_collected',
  status_order_assembled = 'status_order_assembled',
  status_order_in_route_delivery = 'status_order_in_route_delivery',
  status_order_sp_delivered = 'status_order_sp_delivered',
  // they are not used, at the moment
  status_order_in_progress = 'status_order_in_progress',
  status_order_delayed = 'status_order_delayed',
  status_order_sp_cancelled = 'status_order_sp_cancelled',
  status_order_client_cancelled = 'status_order_client_cancelled',
  status_order_sp_rejected = 'status_order_sp_rejected',
  status_order_professional_service_search = 'status_order_professional_search',
  status_order_professional_service_confirmed = 'status_order_professional_confirmed',
}

export enum EOrderPaymentStatuses {
  status_payment_unpaid = 'status_payment_unpaid',
  status_payment_paid = 'status_payment_paid',
  status_payment_declined = 'status_payment_declined',
  status_payment_unpaid_invoice = 'status_payment_unpaid_invoice',
  status_payment_paid_invoice = 'status_payment_paid_invoice',
}

export enum EOrderTypes {
  amazon_return = 'amazon_return',
  bizcocho_order = 'bizcocho_order',
  custom = 'custom',
  delivery_with_code = 'delivery_with_code',
  drop_only = 'drop_only',
  home_delivery = 'home_delivery',
  internal_delivery_1 = 'internal_delivery_1',
  laundry_drop_go = 'laundry_drop_go',
  locker_order = 'locker_order',
  office_order = 'office_order',
  package_transfer = 'package_transfer',
  public_locker = 'public_locker',
  smart_drop = 'smart_drop',
  smart_storage = 'smart_storage',
  professional_service = 'professional_service',
}

export interface IOrderLog {
  id: number;
  order_id: number;
  action: number;
  data: object;
  created_at: string;
}

export interface IOrderTimeslot {
  id: number;
  order_id: number;
  type: string;
  price: number;
  slot: string;
}

export interface IOrderNote {
  id: number;
  comment: string;
  author_user_id: number;
  author_name: string;
  type: string;
  created_at: string;
  deleted_at: string;
}

export interface IOrderPromotion {
  id: number;
  order_id: number;
  promotion_id: number;
  discount: number;
  created_at: string;
  deleted_at: string;
  promotion: IPromotion;
}

export interface IOrderService {
  id: number;
  order_id: number;
  service_id: number|null;
  quantity: number;
  item_price: number;
  discount: number;
  sub_total: number;
  type: string|null;
  notes: string|null;
  custom_locker_cell_size_id: number|null;
  processed: boolean;
  name: string|null;
  created_at: string;
  updated_at: string;
  deleted_at: string|null;
  service: IService|null;
}

export interface IOrder {
  id: number;
  active_from: string | null;
  cancelled_at: string | null;
  channel_id: number;
  confirmed_at: string | null;
  courier: string | null;
  created_at: string;
  deleted_at: string | null;
  delivery_costs: number;
  description: string | null;
  discount_total: string;
  due: string | null;
  grand_total: string;
  invoice_id: number | null;
  last_reminder_time: string | null;
  pickupLocation: IShortLocation;
  pickupCell: ICell|null;
  pickupTimeslots: IOrderTimeslot[];
  deliveryLocation: IShortLocation;
  deliveryCell: ICell|null;
  deliveryTimeslots: IOrderTimeslot[];
  currentCell: ICell|null;
  locked: boolean;
  locker_code: string | null;
  original_id: number | null;
  payment_status: EOrderPaymentStatuses;
  pickup_reminder_counter: number;
  route_leg_id: number | null;
  service_provider: IShortServiceProvider;
  status: EOrderStatuses;
  sub_total: string | null;
  type: EOrderTypes;
  unique_code?: string | null;
  updated_at: string | null;
  user: IShortUser;
  vat: string;
  rating?: number;
  communication_messages?: ICommunicationMessage[];
  logs?: IOrderLog[];
  notes: IOrderNote[];
  services: IOrderService[];
  currency: string;
  promotions: IOrderPromotion[];
  send_communications: boolean;
  transfer_destination_locker_id: number | null;
  hasImage: boolean;
  professional_service_data?: IShortProfessionalServiceData;
  cancellation_reason?: string;
  cancellation_reason_text?: string;
  refund_percentage?: number;
  refund_amount?: string;
  rentback_amount?: number | null;
  discount_code?: string | null;
  community_timezone: string | null;
  spike_error?: ISpikeError | null;

}

export interface ISpikeError {
  operation: string;
  message: string;
  occurredAt: string;
}

export interface IListOrder {
  id: number;
  type: string;
  locker_cell_id?: number;
  user: IShortUser;
  service_provider?: IShortServiceProvider;
  status?: string | null;
  updated_at?: string | null;
  created_at?: string | null;
  spike_error?: ISpikeError | null;
}
